import * as React from "react";
import { useGridApiRef } from "@mui/x-data-grid";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { AgGridReact } from "ag-grid-react";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Skeleton,
  Tooltip,
  tooltipClasses,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import CountryFlag from "react-country-flag";
import countryToFlagCode from "../CountryFlag/CountryFlag";
import Header from "../Header/Header";
import "./Dashboard.css";
import { useState } from "react";
import bg from "../Assets/bg.png";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import packageIMg from "../Assets/Package.png";
import destinationcountry from "../Assets/destinationcountry.png";
import originCountryImg from "../Assets/origincountry.png";
import axiosInstance from "../Utils/AxoisClient";
import { saveAs } from "file-saver";
import excel from "../Assets/excel.png";
import ListboxComponent from "../DynamicAutocomplete/DynamicAutocomplete";
import SkeletonTable from "../SkeletonTable/SkeletonTable";
import { toast, ToastContainer } from "react-toastify";
import { useNavigationType } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setDestinationCountryRedux,
  setHsnCodeRedux,
  setMaterialRedux,
  setOriginCountryRedux,
  setSubcategoryRedux,
} from "../Redux/Reducer/DashboardReducer";

ModuleRegistry.registerModules([AllCommunityModule]);

const MenuProps = {
  PaperProps: {
    style: {
      fontSize: "9px",
      padding: "4px 8px",
    },
  },
};

const selectedBoxStyle = {
  color: " var(--entered-text, #2C2C2E)",
  backgroundColor: "#ffffff",
  borderRadius: 2,
  textAlign: "center",
  background: "#dbdef4",
  textAlign: "left",
  fontSize: "14px",
  padding: "5px",
  fontWeight: 500,
  letterSpacing: "-0.387px",
  border: "none",
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
};

const menuColor = {
  background: "#dbdef4",
};

const parentStyle = {
  position: "relative",
  paddingBottom: "10px",
  backgroundColor: "#f7f8fc",
  marginTop: "67px",
};

const buttonStyleDownload = {
  height: "20px",
};

// function CustomHeaderWithCheckbox(props) {
//   const colDef = props?.colDef || {};
//   const field = colDef.field || props.displayName || colDef.headerName || "";

//   const {
//     selectedHeader = "",
//     onRadioChange = () => {},
//     country = field || colDef.country,
//     countryToFlagCode = {},
//   } = props || {};

//   const isSelected = selectedHeader === field;

//   const handleRadioClick = (event) => {
//     event.stopPropagation(); // Prevent AG Grid from interfering
//     onRadioChange(field);
//   };

//   return (
//     // <div
//     //   style={{
//     //     display: "flex",
//     //     alignItems: "center",
//     //     justifyContent: "center",
//     //     width: "100%",
//     //     fontFamily: "Inter, sans-serif",
//     //     fontWeight: 400,
//     //   }}
//     //   className={isSelected ? "highlighted-header" : ""}
//     //   onClick={(e) => e.stopPropagation()} // Important to allow MUI Radio to be clicked
//     // >
//     //   {field !== "Origin Country" && (
//     //     <label className="radio-container">
//     //       <input
//     //         type="radio"
//     //         checked={isSelected}
//     //         onChange={handleRadioClick}
//     //         size="small"
//     //         sx={{
//     //           color: "grey",
//     //           "&.Mui-checked": {
//     //             color: "#1dc9a0",
//     //           },
//     //         }}
//     //         className="custom-radio"
//     //       />
//     //     </label>
//     //   )}

//     //   <div
//     //     style={{
//     //       display: "flex",
//     //       alignItems: "center",
//     //       justifyContent: "center",
//     //     }}
//     //   >
//     //     {country}
//     //     {country === "Brazil" && "*"}
//     //     <div
//     //       style={{
//     //         width: "20px",
//     //         height: "20px",
//     //         marginLeft: "5px",
//     //         overflow: "hidden",
//     //         display: "inline-block",
//     //       }}
//     //     >
//     //       <CountryFlag
//     //         countryCode={countryToFlagCode[country] || ""}
//     //         svg
//     //         style={{
//     //           width: "100%",
//     //           height: "100%",
//     //           objectFit: "cover",
//     //         }}
//     //       />
//     //     </div>
//     //   </div>
//     // </div>
//     <div
//       style={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center", // center the whole block in the header
//         width: "100%",
//         fontFamily: "Inter, sans-serif",
//         fontWeight: 400,
//       }}
//       className={isSelected ? "highlighted-header" : ""}
//     >
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         {/* Checkbox just 5px left of the name */}
//         {field !== "Origin Country" && (
//           <label
//             className="radio-container"
//             style={{
//               marginRight: "5px", // space between checkbox and country name
//               display: "flex",
//               alignItems: "center",
//             }}
//           >
//             <input
//               type="radio"
//               checked={isSelected}
//               onChange={handleRadioClick}
//               className="custom-radio"
//             />
//           </label>
//         )}

//         {/* Country name + flag */}
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           {country}
//           {country === "Brazil" && "*"}
//           <div
//             style={{
//               width: "20px",
//               height: "20px",
//               marginLeft: "5px",
//               overflow: "hidden",
//               display: "inline-block",
//             }}
//           >
//             <CountryFlag
//               countryCode={countryToFlagCode[country] || ""}
//               svg
//               style={{
//                 width: "100%",
//                 height: "100%",
//                 objectFit: "cover",
//               }}
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
function CustomHeaderWithCheckbox(props) {
  const colDef = props?.colDef || {};
  const field = colDef.field || props.displayName || colDef.headerName || "";

  const {
    selectedHeader = "",
    onRadioChange = () => {},
    country = field || colDef.country,
    countryToFlagCode = {},
  } = props || {};

  const isSelected = selectedHeader === field;

  const handleRadioClick = (event) => {
    event.stopPropagation(); // Prevent AG Grid from interfering
    onRadioChange(field);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center", // center the whole block in the header
        width: "100%",
        fontFamily: "Inter, sans-serif",
        fontWeight: 400,
        // marginLeft: "-9px",
      }}
      className={isSelected ? "highlighted-header" : ""}
      onClick={(e) => e.stopPropagation()} // stop grid sort/filter on click
    >
      {/* Inner block, aligned left */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start", // left align inside the centered block
          // gap: "6px",
          // minWidth: "120px", // keeps consistency across headers
        }}
      >
        {/* Radio */}
        {field !== "Origin Country" && (
          <label
            className="radio-container"
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <input
              type="radio"
              style={{ margin: "2px 0px" }}
              checked={isSelected}
              onChange={handleRadioClick}
              className="custom-radio"
            />
          </label>
        )}

        {/* Country name + flag */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "4px",
          }}
        >
          {country}
          {country === "Brazil" && "*"}
          <div
            style={{
              width: "20px",
              height: "20px",
              overflow: "hidden",
              display: "inline-block",
            }}
          >
            <CountryFlag
              countryCode={countryToFlagCode[country] || ""}
              svg
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectFit: "contain",
                // marginLeft:'2px'
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function ImportTariff() {
  const [selectedMaterial, setSelectedMaterial] = React.useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = React.useState(null);
  const [selectedHSCode, setSelectedHSCode] = React.useState();
  const [selectedHSCodeText, setSelectedHSCodeText] = React.useState("");
  const [selectedHeader, setSelectedHeader] = React.useState(null);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [filteredSelectedRows, setFilteredSelectedRows] = React.useState([]);
  const [originCountry, setOriginCountry] = React.useState([]);
  const [originCountryList, setOriginCountryList] = useState([]);
  const [destinationCountryList, setDestinationCountryList] = useState([]);
  const [tariffData, setTariffData] = useState([]);
  const [destinationCountry, setDestinationCountry] = React.useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [subCategoryInitial, setSubCategoryInitial] = useState([]);
  const [HSCode, setHSCode] = useState([]);
  const [allowNavigation, setAllowNavigation] = React.useState(false);
  const [colDefs, setColDefs] = useState([]);
  const [rows, setRows] = useState([]);
  const [materialList, setMaterialList] = useState([]);
  const [dataItemWidth, setDataItemWidth] = useState(3);
  const [pageSize, setPageSize] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const gridRef = React.useRef();
  const [loading, setLoading] = useState(true);
  const [isReset, setIsReset] = useState(false);

  const [inputValueMaterial, setInputValueMaterial] = useState("");

  const [pageMaterial, setPageMaterial] = useState(1);
  const listboxRefMaterial = React.useRef(null);
  // SubCategory
  const hasInitializedSubCategory = React.useRef(false);
  const [subCategoryPage, setSubCategoryPage] = useState(1);
  const [subCategoryHasMore, setSubCategoryHasMore] = useState(true);
  const [subCategorySearch, setSubCategorySearch] = useState("");
  const [loadingSubCategory, setLoadingSubCategory] = useState(false);

  // HSCode

  const [hsPage, setHsPage] = useState(1);
  const [hsHasMore, setHsHasMore] = useState(true);
  const [hsSearch, setHsSearch] = useState("");
  const [loadingHS, setLoadingHS] = useState(false);

  // Material

  const [materialPage, setMaterialPage] = useState(1);
  const [materialHasMore, setMaterialHasMore] = useState(true);
  const [materialSearch, setMaterialSearch] = useState("");
  const [loadingMaterial, setLoadingMaterial] = useState(false);
  const navType = useNavigationType();
  const {
    subcategoryRedux,
    materialRedux,
    hsnCodeRedux,
    originCountryRedux,
    destinationCountryRedux,
  } = useSelector((state) => state.dashboardData);

  React.useEffect(() => {
    if (navType === "POP") {
      setSelectedSubCategory(subcategoryRedux);
      setSelectedMaterial(materialRedux);
      setSelectedHSCode(hsnCodeRedux);
      setOriginCountry(originCountryRedux);
      setDestinationCountry(destinationCountryRedux);
    } else {
    }
  }, [navType]);

  const totalColumns = 12;
  const buttonWidth = 0.9;

  React.useEffect(() => {
    //for ul for now
    // let dataItems = 5;
    let dataItems = 3;
    // for all
    if (subCategoryInitial?.length > 0) {
      // dataItems = 5;
      dataItems = 3;
    } else if (HSCode?.length > 0 && subCategoryInitial?.length < 1) {
      // dataItems = 4;
      // dataItems = 5;
      dataItems = 3;
    }
    const rawWidth = (totalColumns - buttonWidth) / dataItems;
    const roundedWidth = Math.floor(rawWidth * 100) / 100;
    const lastWidth = +(totalColumns - buttonWidth).toFixed(2);
    const widths = Array(dataItems).fill(roundedWidth);
    const result = Math.round(roundedWidth);
    setDataItemWidth(roundedWidth);
  }, [materialList, subCategoryInitial]);

  const fetchDataSubCategory = async (value) => {
    const payload = { name: value ? value : "" };
    try {
      const response = await axiosInstance.post(
        `company/subcategory-list?limit=500&page=${subCategoryPage}`,
        payload
      );

      const newItems = response?.data?.data || [];

      setSubCategory((prev) =>
        subCategoryPage === 1 ? newItems : [...prev, ...newItems]
      );

      setSubCategoryHasMore(newItems.length > 0);
      // ✅ Only set default selection once
      if (!hasInitializedSubCategory.current && newItems.length > 0) {
        if (navType !== "POP" || !materialRedux?.material_name) {
          setSelectedSubCategory(newItems[0]);
        }
        setSubCategoryInitial(response?.data?.data);
        hasInitializedSubCategory.current = true;
      }

      setLoadingSubCategory(false);
    } catch (error) {
      // toast.error("Failed to fetch data 🎉", { autoClose: 2000 });
    }
  };

  //for sub category list
  React.useEffect(() => {
    fetchDataSubCategory();
  }, [subCategoryPage, HSCode]);

  //to get hsCode
  // React.useEffect(() => {
  //   const fetchData = async () => {
  //     const payload = {
  //       subcategory_id: selectedSubCategory?.id ? selectedSubCategory?.id : "",
  //     };
  //     try {
  //       const response = await axiosInstance.post(
  //         "company/hsncode-list?limit=400&page=1",
  //         {
  //           ...payload,
  //         }
  //       );
  //       setHSCode(response?.data?.data);
  //       if (response?.data?.data.length > 0) {
  //         if (navType !== "POP" || !materialRedux?.material_name ) {
  //           setSelectedHSCode(response?.data?.data[0]);
  //         }
  //       }
  //     } catch (error) {
  //       // toast.error(error?.response?.data?.message, { autoClose: 2000 });
  //     }
  //   };

  //   fetchData();
  // }, [selectedSubCategory]);

  // React.useEffect(() => {
  //   const controller = new AbortController();
  //   const timer = setTimeout(() => {
  //     const fetchData = async () => {
  //       const payload = {
  //         subcategory_id: selectedSubCategory?.id || "",
  //       };
  //       try {
  //         const response = await axiosInstance.post(
  //           "company/hsncode-list?limit=400&page=1",
  //           payload,
  //           { signal: controller.signal }
  //         );
  //         setHSCode(response?.data?.data);
  //         if (response?.data?.data.length > 0) {
  //           if (navType !== "POP" || !materialRedux?.material_name) {
  //             setSelectedHSCode(response?.data?.data[0]);
  //           }
  //         }
  //         // setHSCode(response?.data?.data);
  //       } catch (error) {
  //         if (error.name !== "CanceledError") console.error(error);
  //       }
  //     };

  //     // fetch only if needed
  //     if (selectedSubCategory) fetchData();
  //   }, 300);

  //   return () => {
  //     clearTimeout(timer);
  //     controller.abort();
  //   };
  // }, [selectedSubCategory]);

  React.useEffect(() => {
    const controller = new AbortController();
    const timer = setTimeout(() => {
      const fetchData = async () => {
        const payload = {
          subcategory_id: selectedSubCategory?.id || "",
        };

        try {
          const response = await axiosInstance.post(
            "company/hsncode-list?limit=400&page=1",
            payload,
            { signal: controller.signal }
          );
          setHSCode(response?.data?.data);
          if (response?.data?.data.length > 0) {
            if (navType !== "POP" || !materialRedux?.material_name) {
              setSelectedHSCode(response?.data?.data[0]);
            }
          }
        } catch (error) {
          if (error.name !== "CanceledError") console.error(error);
        }
      };

      // ✅ Always call (even if payload is empty)
      fetchData();
    }, 300);

    return () => {
      clearTimeout(timer);
      controller.abort();
    };
  }, [selectedSubCategory]);

  // get Material list
  const fetchData = async (value) => {
    // if (!selectedHSCode?.hsncode && !selectedSubCategory?.id) return;
    // if (!value && !selectedHSCode?.hsncode && !selectedSubCategory?.id) return;

    setLoadingMaterial(true);

    const payload = {
      subcategory_id: selectedSubCategory?.id || "",
      hsncode: selectedHSCode?.hsncode || "",
      material_name: value ? value : "",
    };

    try {
      const response = await axiosInstance.post(
        "company/material-list?limit=400&page=1",
        payload
      );

      const materials = response?.data?.data || [];
      // setMaterialList((prev) => [...prev, ...materials]);
      setMaterialList(materials);
      if (materials.length > 0 && !value) {
        // setSelectedMaterial({ material_name: materials[0].material_name });
      }
    } catch (error) {
      // toast.error("Failed to fetch data", { autoClose: 2000 });
    } finally {
      setLoadingMaterial(false);
    }
  };

  React.useEffect(() => {
    fetchData(false);
  }, [selectedHSCode, selectedSubCategory]);

  // for all tariff and origin country and destination country list
  React.useEffect(() => {
    // if (selectedHSCode?.hsncode == null) return;
    const fetchData = async () => {
      try {
        const response = await axiosInstance.post(
          `company/get-tariff  
          `,
          {
            name: selectedMaterial?.material_name || "",
            origin_country: originCountry?.toString() || "",
            destination_country: destinationCountry?.toString() || "",
            subcategory_id: selectedSubCategory?.id
              ? selectedSubCategory?.id
              : "",
            hsncode: selectedHSCode ? selectedHSCode?.hsncode : "",
          }
        );
        if (navType !== "pop" || !materialRedux?.material_name) {
          // setOriginCountryList(response?.data?.data?.originCountry);
          setOriginCountryList(
            response?.data?.data?.originCountry
              ?.slice()
              ?.sort((a, b) => a.localeCompare(b))
          );
          // setDestinationCountryList(response?.data?.data?.destinationCountry);
          setDestinationCountryList(
            response?.data?.data?.destinationCountry
              ?.slice()
              ?.sort((a, b) => a.localeCompare(b))
          );
        }
        setTariffData(response?.data?.data?.tariffData?.rows);
        setLoading(false);
        setTotalPages(response?.data?.data?.tariffData?.totalPages);
      } catch (error) {
        setLoading(false);
        if (
          error?.response?.data?.message ===
          "Please pass category or HS Code or Material"
        ) {
          // toast.error("Please provide category , HS Code or Material", {
          //   autoClose: 2000,
          // });
          setRows([]);
        }
      }
    };
    fetchData();
  }, [
    selectedMaterial,
    HSCode,
    originCountry,
    destinationCountry,
    pageSize,
    currentPage,
    selectedSubCategory,
    selectedHSCode,
  ]);

  React.useEffect(() => {
    if (!allowNavigation && location.pathname === "/tariff-tool") {
      navigate(-1);
    } else if (allowNavigation && location.pathname === "/tariff-tool") {
      setAllowNavigation(true);
    }
  }, [allowNavigation, location, navigate]);

  // React.useEffect(() => {
  //   if (navType === "pop" || !materialRedux?.material_name) return;
  //   // setOriginCountry([]);
  //   // setDestinationCountry([]);
  // }, [selectedMaterial]);
  const [skippedReset, setSkippedReset] = React.useState(false);

  React.useEffect(() => {
    if (!selectedMaterial || !materialRedux?.material_name) return;

    if (navType === "pop" && !skippedReset) {
      // skip reset on first render after pop
      setSkippedReset(true);
      return;
    }

    // when user changes material manually, reset
    // setOriginCountry([]);
    // setDestinationCountry([]);
  }, [selectedMaterial, materialRedux?.material_name, navType, skippedReset]);

  // header data
  React.useEffect(() => {
    const seenDestinations = new Set();
    const uniqueTariffData = tariffData.filter((country) => {
      const name = country?.destination_country_name;
      if (!name || seenDestinations.has(name)) return false;
      seenDestinations.add(name);
      return true;
    });
    const columns = [
      {
        field: "Origin Country",
        headerName: `Tariff %`,
        minWidth: 150,
        sortable: true,
        pinned: "left",
        checkboxSelection: true,
        headerCheckboxSelection: true,
        cellClass: "sticky-column",
        headerClass: "sticky-column-first",
        cellRenderer: (params) => {
          const originCountry = params?.data?.origin_country_name || "";
          const countryCode =
            countryToFlagCode[params?.data?.origin_country_name] || "";

          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <div
                style={{
                  width: "25px",
                  height: "25px",
                  marginRight: "8px",
                  overflow: "hidden",
                  display: "inline-block",
                  fontWeight: "400 !important",
                }}
              >
                <CountryFlag
                  countryCode={countryCode}
                  svg
                  style={{
                    width: "100%",
                    height: "100%",
                    verticalAlign: "top",
                    objectFit: "cover",
                  }}
                />
              </div>
              {originCountry}
            </div>
          );
        },
      },
      ...uniqueTariffData.map((country) => {
        const destinationName = country?.destination_country_name;
        const fieldName = destinationName;
        return {
          field: fieldName,
          headerName: destinationName,
          flex: 1,
          minWidth:
            typeof destinationName === "string" && destinationName.length > 8
              ? destinationName.length > 13
                ? 230
                : 210
              : 172,
          width:
            typeof destinationName === "string" && destinationName.length > 10
              ? 210
              : 120,
          sortable: true,
          suppressMenu: true,
          headerComponent: CustomHeaderWithCheckbox,
          cellRenderer: (params) => {
            const isNumber = typeof params.value === "number";
            const isSelf =
              params.colDef.field === params.data.origin_country_name;

            let label;
            if (isNumber) {
              label = `${params.value.toFixed(1)}%`;
            } else if (isSelf) {
              label = "";
            } else {
              //  label = "N/A";
              label = "";
            }

            return (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center", // centers whole block
                  alignItems: "center",
                  height: "100%",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start", // children aligned left
                    // gap: "6px",                   // spacing between dot and text
                    minWidth: "80px", // keeps consistent width so alignment doesn't jump
                  }}
                >
                  <span
                    className={`dot ${
                      !isNumber
                        ? //  ? "dot-gray"
                          ""
                        : params.value > 20
                        ? "dot-gold"
                        : params.value <= 10
                        ? "dot-green"
                        : "dot-blue"
                    }`}
                    style={{
                      display: "inline-block",
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                    }}
                  />
                  <span
                    className={`value-span ${
                      isNumber ? "value-span-normal" : "value-span-bold"
                    } ${
                      !isNumber
                        ? "color-gray"
                        : params.value > 20
                        ? "color-gold"
                        : params.value <= 10
                        ? "color-green"
                        : "color-blue"
                    }`}
                  >
                    {label}
                  </span>
                </div>
              </div>
            );
          },
          cellClass: (params) =>
            params.colDef.field === selectedHeader ? "highlighted-column" : "",
          headerComponentParams: {
            selectedHeader,
            onRadioChange: setSelectedHeader,
            countryToFlagCode,
          },
        };
      }),
    ];

    setColDefs(columns);
  }, [
    originCountry,
    destinationCountry,
    selectedHeader,
    selectedMaterial,
    // data,
    tariffData,
  ]);

  //set filtered row
  React.useEffect(() => {
    if (selectedHeader) {
      let newSelectedRows = [...selectedRows];
      newSelectedRows = newSelectedRows.filter(
        (row) =>
          row.origin_country_name === selectedHeader ||
          row[selectedHeader] !== "N/A"
      );
      setFilteredSelectedRows(newSelectedRows);
    }
  }, [selectedHeader, selectedRows]);

  // rows data set here
  React.useEffect(() => {
    const allDestinations = [
      ...new Set(tariffData.map((item) => item.destination_country_name)),
    ];

    const rowMap = new Map();

    tariffData.forEach((item) => {
      const origin = item.origin_country_name?.trim();
      const dest = item.destination_country_name?.trim();
      const tariffValue = origin == dest ? "" : item.tariff;
      // const tariffValue = item.tariff;

      if (!rowMap.has(origin)) {
        const row = {
          id: rowMap.size + 1,
          origin_country_name: origin?.trim(),
          Date_time: item.Date_Time || "",
          FlagCode: countryToFlagCode[origin?.trim()] || "",
        };

        allDestinations.forEach((destCountry) => {
          // row[destCountry] = "N/A";
          row[destCountry] = "";
        });

        row[dest] = tariffValue;
        rowMap.set(origin, row);
      } else {
        const existingRow = rowMap.get(origin);
        existingRow[dest] = tariffValue;
      }
    });
    const rows = Array.from(rowMap.values());
    setRows(rows);
  }, [selectedMaterial, selectedSubCategory, selectedHSCode, tariffData]);

  //update material or material selection
  function updateChange(e) {
    setSelectedMaterial(e.target.value);
    setOriginCountry([]);
    setDestinationCountry([]);
    setLoading(true);
  }

  let debounceTimer;

  function updateChangeMaterial(e) {
    const newVal = e.target.value;

    // Normalize input
    const materialName =
      typeof newVal === "string" ? newVal : newVal?.material_name || "";

    // Clear previous timer
    clearTimeout(debounceTimer);

    // Set new timer
    debounceTimer = setTimeout(() => {
      fetchData(materialName);
    }, 300); // 300ms debounce
  }

  //update sub category or  sub category selection
  function updateChangeSubCategory(e) {
    setSelectedSubCategory(e.target.value);
    setSelectedRows([]);
    setSelectedHeader("");
    setSelectedMaterial({
      material_name: null,
    });
    setHSCode([]);
    setSelectedHSCode({
      hsncode: "",
    });
    setLoading(true);
  }

  let debounceTimerSubCategory;
  function updateChangeSubCategoryTextInput(e) {
    const newVal = e.target.value;

    // Normalize input
    const textValue = typeof newVal === "string" ? newVal : newVal?.name || "";

    // Clear previous timer
    clearTimeout(debounceTimerSubCategory);

    // Set new timer
    debounceTimerSubCategory = setTimeout(() => {
      fetchDataSubCategory(textValue);
    }, 300); // 300ms debounce
  }

  //  //update hs code or  hs code selection
  function updateChangeHSCode(e) {
    setSelectedHSCode(e.target.value);
    setSelectedHSCodeText(e.target.value?.hs_code_short_description);
    setSelectedRows([]);
    setSelectedHeader("");
    setSelectedMaterial({
      material_name: null,
    });
  }

  // for  origin country all check
  function upOriginCountry(e) {
    const {
      target: { value },
    } = e;

    if (value.includes("all")) {
      if (originCountry.length === originCountryList.length) {
        setOriginCountry([]);
      } else {
        setOriginCountry(originCountryList.map((item) => item));
      }
    } else {
      setOriginCountry(typeof value === "string" ? value.split(",") : value);
    }
  }
  // for  origin destination all check
  function updateDestinationCountry(e) {
    const {
      target: { value },
    } = e;

    if (value.includes("all")) {
      if (destinationCountry.length === destinationCountryList.length) {
        setDestinationCountry([]);
      } else {
        setDestinationCountry(destinationCountryList.map((item) => item));
      }
    } else {
      setDestinationCountry(
        typeof value === "string" ? value.split(",") : value
      );
    }
  }

  function handleReset() {
    setOriginCountry([]);
    setIsReset(true);
    setDestinationCountry([]);
    dispatch(setMaterialRedux(null));
    dispatch(setHsnCodeRedux(null));
    dispatch(setSubcategoryRedux(null));
    dispatch(setOriginCountryRedux([]));
    dispatch(setDestinationCountryRedux([]));
    setSelectedMaterial({
      material_name: null,
    });
    setSelectedHSCode();
    setSelectedHSCodeText("");
    setSelectedSubCategory(null);
    hasInitializedSubCategory.current = false;
    setSubCategoryPage(1);
  }

  const onSelectionChanged = (event) => {
    const selectedNodes = event.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    //suggest by pooja on date 16-12-2025
    // if (selectedData.length > 10) {
    //   // Deselect all first
    //   event.api.deselectAll();

    //   // Select only the first 10
    //   selectedNodes.slice(0, 10).forEach((node) => node.setSelected(true));

    //   alert("You can select only 10 rows!");
    // }
    setSelectedRows(event.api.getSelectedRows());
  };

  //download tariff list
  const downloadExcel = async () => {
    // if (selectedMaterial?.material_name == null) return;
    const payload = {
      name: selectedMaterial?.material_name || "",
      origin_country: originCountry?.toString() || "",
      destination_country: destinationCountry?.toString() || "",
      subcategory_id: selectedSubCategory?.id,
      hsncode: selectedHSCode ? selectedHSCode?.hsncode : "",
      period_value: "",
    };
    try {
      const response = await axiosInstance.post(
        "company/export-tariff",
        payload,
        {
          responseType: "blob",
        }
      );
      // const disposition = response.headers.get("content-disposition");
      const disposition = response.headers.get("Content-Disposition");
      // const match = disposition && disposition.match(/filename="(.+)"/);
      // const filename = match ? match[1] : 'Tariff_Matrix.xlsx';
      let filename = "download.xlsx";
      if (disposition && disposition.includes("filename=")) {
        const matches = disposition.match(/filename="?(.+?)"?(\s*;|$)/);
        if (matches && matches[1]) {
          filename = matches[1];
        }
      }

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, filename);
      // return response;
    } catch (error) {
      // toast.error(error?.response?.data?.message, { autoClose: 2000 });
    }
  };

  //set table data null when all selected value are null
  React.useEffect(() => {
    if (!selectedHSCode && !selectedMaterial && !selectedSubCategory) {
      setRows([]);
      setColDefs([]);
      setTariffData([]);
    }
  }, [selectedHSCode, selectedMaterial, selectedSubCategory]);

  // Called when page changes
  const onPaginationChanged = () => {
    if (gridRef.current && gridRef.current.api) {
      const api = gridRef?.current?.api;
      const pageSize = gridRef?.current?.api?.paginationGetPageSize();
      const newPage = api?.paginationGetCurrentPage() + 1; // 0-based index
      const total = api?.paginationGetTotalPages();
      setCurrentPage(newPage);
      setPageSize(pageSize);
    }
  };

  React.useEffect(() => {
    dispatch(setMaterialRedux(selectedMaterial));
    dispatch(setHsnCodeRedux(selectedHSCode));
    dispatch(setSubcategoryRedux(selectedSubCategory));
    dispatch(setOriginCountryRedux(originCountry));
    dispatch(setDestinationCountryRedux(destinationCountry));
  }, [
    selectedMaterial,
    selectedHSCode,
    selectedSubCategory,
    originCountry,
    destinationCountry,
  ]);

  return (
    <>
      <Header />
      <ToastContainer position="top-right" />
      <Box
        sx={{
          ...parentStyle,
        }}
      >
        <div className="overlayStyle">
          <Box
            className="content_style"
            sx={{
              backgroundImage: `url(${bg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="para_style">
              <h4 style={{ margin: "5px" }}>TOOL GUIDE:</h4>
              <>
                <ol>
                  <li>
                    Select the required material from the drop down below and
                    choose the Origin and Destination countries of interest.
                  </li>
                  <li>
                    From the Tariff Matrix, tick the boxes for desired
                    combinations of Origin & Destination country for viewing the
                    DDP price breakdown.
                  </li>
                  <li>
                    Select the 'Click for more Details' button on the bottom
                    right to go to the Detailed View.
                  </li>
                </ol>
              </>
            </div>
          </Box>
          <Box className="main_cell">
            <Box className="dropdown_header">
              <Box className="dropdown_container">
                <Grid container spacing={2}>
                  {/* //sub category */}
                  {subCategory && (
                    <>
                      {/* {SubCategory} */}
                      <Grid
                        item
                        xs={12}
                        // lg={dataItemWidth}
                        lg={3.7}
                      >
                        {true && (
                          <>
                            <Box className="label_name">
                              <img src={packageIMg} alt="img" />
                              {/* &nbsp; Select SubCategory */}
                              &nbsp; Select Category
                            </Box>
                            <Autocomplete
                              freeSolo
                              options={subCategory}
                              getOptionLabel={(option) =>
                                typeof option === "string"
                                  ? option
                                  : option?.name || ""
                              }
                              value={selectedSubCategory ?? null}
                              loading={loadingSubCategory}
                              onChange={(event, newValue) =>
                                updateChangeSubCategory({
                                  target: {
                                    value:
                                      typeof newValue === "string"
                                        ? { name: newValue }
                                        : newValue,
                                  },
                                })
                              }
                              onInputChange={(event, newInputValue, reason) => {
                                setSubCategorySearch(newInputValue);
                                setSubCategoryPage(1);
                                if (reason === "input") {
                                  updateChangeSubCategoryTextInput({
                                    target: {
                                      value: { name: newInputValue },
                                    },
                                  });
                                }
                              }}
                              ListboxComponent={(props) => (
                                <ListboxComponent
                                  {...props}
                                  onScrollBottom={() => {
                                    if (
                                      subCategoryHasMore &&
                                      !loadingSubCategory
                                    ) {
                                      setSubCategoryPage((prev) => prev + 1);
                                    }
                                  }}
                                />
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Search or Select Category"
                                  size="small"
                                  sx={{
                                    ...selectedBoxStyle,
                                    "& .MuiInputBase-root": {
                                      height: "32px",
                                      fontSize: "12px",
                                    },
                                    "& .MuiInputBase-input": {
                                      padding: "8px 12px",
                                      fontSize: "12px",
                                    },
                                  }}
                                />
                              )}
                              sx={{
                                "& .MuiAutocomplete-inputRoot": {
                                  paddingRight: "32px !important",
                                },
                                "& .MuiAutocomplete-clearIndicator": {
                                  color: "#fff",
                                  backgroundColor: "#1976d2",
                                  borderRadius: "50%",
                                  "&:hover": {
                                    backgroundColor: "#1565c0",
                                    fontSize: ".8rem",
                                  },
                                },
                              }}
                              componentsProps={{
                                popper: {
                                  sx: {
                                    "& .MuiAutocomplete-option": {
                                      minHeight: "24px",
                                      fontSize: "12px",
                                      padding: "2px 8px",
                                    },
                                  },
                                },
                              }}
                            />

                            {/* </FormControl> */}
                          </>
                        )}
                      </Grid>
                    </>
                  )}
                  {/* hs code */}
                  {HSCode && (
                    <Grid
                      item
                      xs={12}
                      // lg={dataItemWidth}
                      lg={7.4}
                    >
                      {true && (
                        <>
                          <Box className="label_name">
                            <img src={originCountryImg} alt="img" />
                            &nbsp;
                            <span>Select HS Code</span>
                          </Box>
                          <FormControl fullWidth>
                            <Autocomplete
                              options={HSCode}
                              renderOption={(props, option) => (
                                <Tooltip
                                  title={
                                    option.hsncode +
                                    "--" +
                                    option?.hs_code_short_description
                                  }
                                >
                                  <li {...props}>
                                    {option.hsncode +
                                      "--" +
                                      option?.hs_code_short_description}
                                  </li>
                                </Tooltip>
                              )}
                              // getOptionLabel={(option) =>
                              //   option?.hsncode +
                              //   (option?.hsncode ? " -- " : "") +
                              //   option?.hs_code_short_description
                              // }
                              getOptionLabel={(option) => {
                                const hsncode = option?.hsncode || "";
                                const description =
                                  option?.hs_code_short_description || "";
                                return hsncode
                                  ? `${hsncode} -- ${description}`
                                  : description;
                              }}
                              // getOptionLabel={(option) => option.hsncode}
                              value={selectedHSCode ?? null}
                              // onChange={(event, newValue) =>
                              //   updateChangeHSCode({
                              //     target: {
                              //       value: newValue,
                              //     },
                              //   })

                              // }
                              onChange={(event, newValue, reason) => {
                                // Main HS code change handler
                                updateChangeHSCode({
                                  target: { value: newValue },
                                });
                                // Detect clear action
                                if (reason?.trim() === "clear") {
                                  // Reset other related states here
                                  setSelectedMaterial({
                                    material_name: null,
                                  });
                                  // etc...
                                }
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder="Search or Select HS code"
                                  size="small"
                                  sx={{
                                    ...selectedBoxStyle,
                                    "& .MuiInputBase-root": {
                                      height: "32px",
                                      fontSize: "12px",
                                    },
                                    "& .MuiInputBase-input": {
                                      padding: "8px 12px",
                                      fontSize: "12px",
                                    },
                                  }}
                                />
                              )}
                              sx={{
                                "& .MuiAutocomplete-inputRoot": {
                                  paddingRight: "32px !important",
                                },
                                "& .MuiAutocomplete-clearIndicator": {
                                  color: "#fff", // text color (icon color)
                                  backgroundColor: "#1976d2", // background color
                                  borderRadius: "50%", // make it round (optional)
                                  "&:hover": {
                                    backgroundColor: "#1565c0", // background on hover
                                  },
                                },
                              }}
                              componentsProps={{
                                popper: {
                                  sx: {
                                    "& .MuiAutocomplete-option": {
                                      minHeight: "24px",
                                      fontSize: "12px",
                                      padding: "2px 8px",
                                    },
                                  },
                                },
                              }}
                            />
                          </FormControl>
                        </>
                      )}
                    </Grid>
                  )}

                  {/* new material */}

                  <Grid item xs={12} lg={dataItemWidth}>
                    {true && (
                      <>
                        <Box className="label_name">
                          <img src={packageIMg} alt="img" />
                          &nbsp; Select Material
                        </Box>

                        {/* <Autocomplete
                          freeSolo
                          // options={Material}
                          options={materialList}
                          // getOptionLabel={(option) => option.material_name}
                          getOptionLabel={(option) =>
                            typeof option === "string"
                              ? option
                              : option.material_name
                          }
                          value={selectedMaterial}
                          onChange={(event, newValue) =>
                            updateChange({
                              target: { value: newValue },
                            })
                          }
                          onInputChange={(event, newInputValue) => {
                                                   
                            // fires on every keystroke when freeSolo
                            // use this if you want to capture typed text
                            if (event?.type === "change") {
                              updateChange({
                                target: { value: newInputValue },
                              });
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Search or Select Material"
                              size="small"
                              sx={{
                                ...selectedBoxStyle,
                                "& .MuiInputBase-root": {
                                  height: "32px",
                                  fontSize: "12px",
                                },
                                "& .MuiInputBase-input": {
                                  padding: "8px 12px",
                                  fontSize: "12px",
                                },
                              }}
                            />
                          )}
                          sx={{
                            "& .MuiAutocomplete-inputRoot": {
                              paddingRight: "32px !important",
                            },
                            "& .MuiAutocomplete-clearIndicator": {
                              color: "#fff", // text color (icon color)
                              backgroundColor: "#1976d2", // background color
                              borderRadius: "50%", // make it round (optional)
                              "&:hover": {
                                backgroundColor: "#1565c0", // background on hover
                              },
                            },
                          }}
                          componentsProps={{
                            popper: {
                              sx: {
                                "& .MuiAutocomplete-option": {
                                  minHeight: "24px",
                                  fontSize: "12px",
                                  padding: "2px 8px",
                                },
                              },
                            },
                          }}
                        /> */}
                        {/* <Autocomplete
                          freeSolo
                          options={materialList}
                          getOptionLabel={(option) =>
                            typeof option === "string"
                              ? option
                              : option?.material_name || ""
                          }
                          value={selectedMaterial}
                          onChange={(event, newValue) => {
                            // newValue can be: null | string | object
                            let valueToSave =
                              typeof newValue === "string"
                                ? { material_name: newValue } // wrap string in object
                                : newValue;

                            updateChange({
                              target: { value: valueToSave },
                            });
                          }}
                          onInputChange={(event, newInputValue, reason) => {
                            // only capture free typing (not when clearing or selecting from list)
                            if (reason === "input") {
                              updateChangeMaterial({
                                target: {
                                  value: { material_name: newInputValue },
                                },
                              });
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Search or Select Material"
                              size="small"
                              sx={{
                                ...selectedBoxStyle,
                                "& .MuiInputBase-root": {
                                  height: "32px",
                                  fontSize: "12px",
                                },
                                "& .MuiInputBase-input": {
                                  padding: "8px 12px",
                                  fontSize: "12px",
                                },
                              }}
                            />
                          )}
                          sx={{
                            "& .MuiAutocomplete-inputRoot": {
                              paddingRight: "32px !important",
                            },
                            "& .MuiAutocomplete-clearIndicator": {
                              color: "#fff",
                              backgroundColor: "#1976d2",
                              borderRadius: "50%",
                              "&:hover": {
                                backgroundColor: "#1565c0",
                              },
                            },
                          }}
                          componentsProps={{
                            popper: {
                              sx: {
                                "& .MuiAutocomplete-option": {
                                  minHeight: "24px",
                                  fontSize: "12px",
                                  padding: "2px 8px",
                                },
                              },
                            },
                          }}
                        /> */}
                        <Autocomplete
                          freeSolo
                          options={materialList}
                          getOptionLabel={(option) =>
                            typeof option === "string"
                              ? option
                              : option?.material_name || ""
                          }
                          // 👇 unwrap value for Autocomplete
                          value={
                            selectedMaterial
                              ? selectedMaterial.material_name ||
                                selectedMaterial
                              : null
                          }
                          onChange={(event, newValue) => {
                            let valueToSave =
                              typeof newValue === "string"
                                ? { material_name: newValue }
                                : newValue;

                            updateChange({
                              target: { value: valueToSave },
                            });
                          }}
                          onInputChange={(event, newInputValue, reason) => {
                            if (reason === "input") {
                              updateChangeMaterial({
                                target: {
                                  value: { material_name: newInputValue },
                                },
                              });
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Search or Select Material"
                              size="small"
                              sx={{
                                ...selectedBoxStyle,
                                "& .MuiInputBase-root": {
                                  height: "32px",
                                  fontSize: "12px",
                                },
                                "& .MuiInputBase-input": {
                                  padding: "8px 12px",
                                  fontSize: "12px",
                                },
                              }}
                            />
                          )}
                          sx={{
                            "& .MuiAutocomplete-inputRoot": {
                              paddingRight: "32px !important",
                            },
                            "& .MuiAutocomplete-clearIndicator": {
                              color: "#fff",
                              backgroundColor: "#1976d2",
                              borderRadius: "50%",
                              "&:hover": {
                                backgroundColor: "#1565c0",
                              },
                            },
                          }}
                          componentsProps={{
                            popper: {
                              sx: {
                                "& .MuiAutocomplete-option": {
                                  minHeight: "24px",
                                  fontSize: "12px",
                                  padding: "2px 8px",
                                },
                              },
                            },
                          }}
                        />
                      </>
                    )}
                  </Grid>

                  {/* origin Country  */}
                  <Grid item xs={12} lg={dataItemWidth}>
                    <Box className="label_name">
                      <img src={originCountryImg} alt="img" />
                      &nbsp;
                      <Tooltip
                        title="Use this drop down to filter the required origin country in the table below."
                        placement="right"
                      >
                        <span>Origin Country</span>*
                      </Tooltip>
                    </Box>
                    <FormControl fullWidth>
                      <Select
                        fullWidth
                        labelId="demo-multiple-checkbox-label"
                        id="demo-multiple-checkbox"
                        value={originCountry}
                        onChange={(e) => upOriginCountry(e)}
                        size="small"
                        multiple
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        sx={{
                          ...selectedBoxStyle,
                          fontSize: "12px",
                          padding: "4px 12px",
                        }}
                        renderValue={(selected) => {
                          if (selected.length === 0) {
                            return <>Select</>;
                          }
                          return selected.join(", ");
                        }}
                        MenuProps={MenuProps}
                      >
                        <MenuItem
                          value="all"
                          sx={{
                            ...menuColor,
                            fontSize: "12px",
                            padding: "4px 12px",
                            height: "32px",
                          }}
                        >
                          <Checkbox
                            checked={
                              originCountry.length === originCountryList.length
                            }
                          />
                          Select All
                        </MenuItem>
                        {originCountryList.map((item, index) => (
                          <MenuItem
                            key={index}
                            value={item}
                            sx={{
                              ...menuColor,
                              fontSize: "12px",
                              padding: "4px 12px",
                              height: "32px",
                            }}
                          >
                            <Checkbox checked={originCountry.includes(item)} />
                            {item}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* destination country */}

                  <Grid item xs={12} lg={dataItemWidth}>
                    <Box className="label_name">
                      <img src={destinationcountry} alt="img" />
                      &nbsp; <span>Destination Country</span>
                    </Box>
                    <FormControl fullWidth>
                      <Select
                        fullWidth
                        labelId="demo-multiple-checkbox-label"
                        id="demo-multiple-checkbox"
                        multiple
                        displayEmpty
                        value={destinationCountry}
                        onChange={(e) => updateDestinationCountry(e)}
                        // label="Destination Country"
                        size="small"
                        sx={{
                          ...selectedBoxStyle,
                          fontSize: "12px",
                          padding: "4px 12px",
                          // height: "32px",
                        }}
                        renderValue={(selected) => {
                          if (selected.length === 0) {
                            return <>Select</>;
                          }
                          return selected.join(", ");
                        }}
                        MenuProps={MenuProps}
                      >
                        <MenuItem
                          value="all"
                          sx={{
                            ...menuColor,
                            fontSize: "12px",
                            padding: "4px 12px",
                            height: "32px",
                          }}
                        >
                          <Checkbox
                            checked={
                              destinationCountry.length ===
                              destinationCountryList.length
                            }
                          />
                          Select All
                        </MenuItem>
                        {destinationCountryList.map((item, index) => {
                          return (
                            <MenuItem
                              key={index}
                              value={item}
                              sx={{
                                ...menuColor,
                                fontSize: "12px",
                                padding: "4px 12px",
                              }}
                            >
                              <Checkbox
                                checked={destinationCountry.includes(item)}
                              />
                              {item}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* button */}
                  <Grid item xs={12} lg={buttonWidth}>
                    <div className="reset_button">
                      {/* <Box className="label_name"></Box>
                      <Box className="label_name"></Box>
                      <Box className="label_name"></Box> */}
                      <Button
                        sx={{
                          background: "#f7f8fc",
                          color: "#4A4AFF",
                          textTransform: "none",
                        }}
                        onClick={handleReset}
                        size="large"
                      >
                        {/* Reset Table */}
                        Reset
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </Box>
            </Box>
            {/* datagrid  */}
            {loading ? (
              // Skeleton loader table
              <SkeletonTable rows={6} columns={3} />
            ) : (
              <div style={{ margin: "10px 10px 0px 10px" }}>
                <div className="wrapper_datagrid">
                  <div className="wrapper_sidebar">
                    <span className="sidebar_style">Sourcing Country</span>
                    <span className="svg_style">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="9"
                        height="62"
                        viewBox="0 0 9 101"
                        fill="none"
                      >
                        <path
                          d="M4.14645 100.354C4.34171 100.549 4.65829 100.549 4.85355 100.354L8.03553 97.1716C8.2308 96.9763 8.2308 96.6597 8.03553 96.4645C7.84027 96.2692 7.52369 96.2692 7.32843 96.4645L4.5 99.2929L1.67157 96.4645C1.47631 96.2692 1.15973 96.2692 0.964466 96.4645C0.769204 96.6597 0.769204 96.9763 0.964466 97.1716L4.14645 100.354ZM4 0V100H5V0H4Z"
                          fill="#00008B"
                        />
                      </svg>
                    </span>
                  </div>
                  <div style={{ flex: 2, overflowX: "auto" }}>
                    <div className="datagrid_header">
                      <div className="header_first">
                        <div className="header_text">
                          <span style={{ flex: 1, whiteSpace: "nowrap" }}>
                            Destination Country
                          </span>
                          <span className="arrow_style">
                            {/* <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={75vh}
                              height="8"
                              viewBox="0 0 101 9"
                              fill="none"
                            > */}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 101 9"
                              fill="none"
                              style={{ width: "75%", height: "8" }}
                            >
                              <path
                                d="M100.354 4.85355C100.549 4.65829 100.549 4.34171 100.354 4.14645L97.1716 0.964466C96.9763 0.769204 96.6597 0.769204 96.4645 0.964466C96.2692 1.15973 96.2692 1.47631 96.4645 1.67157L99.2929 4.5L96.4645 7.32843C96.2692 7.52369 96.2692 7.84027 96.4645 8.03553C96.6597 8.2308 96.9763 8.2308 97.1716 8.03553L100.354 4.85355ZM0 5L100 5V4L0 4L0 5Z"
                                fill="#00008B"
                              />
                            </svg>
                          </span>
                        </div>
                        <div></div>
                      </div>
                      <div className="header_second">
                        <div
                          className="download-button-header"
                          // className="badge"
                        >
                          <IconButton
                            onClick={() => {
                              downloadExcel();
                            }}
                            size="small" // reduces IconButton padding
                            // disabled={!selectedMaterial}

                            sx={{
                              p: 0.5, // padding inside the button
                              width: 24, // optional: control button width
                              height: 24, // optional: control button height
                              ...buttonStyleDownload,
                              // color: selectedMaterial ? "inherit" : "gray",
                              // opacity: selectedMaterial ? 1 : 0.4,
                              color: "inherit",
                              opacity: 1,
                            }}
                          >
                            <img
                              src={excel}
                              alt="Excel Icon"
                              style={{
                                width: 25, // smaller icon width
                                height: 25, // smaller icon height
                                objectFit: "contain",
                              }}
                            />
                          </IconButton>
                        </div>
                        {/* number list badge */}
                        {/* <div>
                        <div
                          className="badge"
                          style={{
                            // backgroundColor: "#CDFFCD",
                            color: "#007F00",
                          }}
                        >
                          &#x25CF; &lt;=10%
                        </div>
                      </div>
                      <div>
                        <div
                          className="badge"
                          style={{
                            // backgroundColor: "#CECEFC",
                            color: "#4A4AFF",
                          }}
                        >
                          &#x25CF; 10.1% - 20%
                        </div>
                      </div>
                      <div>
                        <div
                          className="badge"
                          style={{
                            color: "#936F00",
                          }}
                        >
                          &#x25CF; &gt;20%
                        </div>
                      </div> */}
                      </div>
                    </div>
                    <Box
                      sx={{
                        overflowX: "auto",
                        height: "75vh",
                        overflowX: "auto",
                        position: "relative",
                      }}
                    >
                      <div className="ag-theme-alpine my-gradient-header-first datagrid-design">
                        <AgGridReact
                          ref={gridRef}
                          rowData={rows}
                          columnDefs={colDefs}
                          className="no-border-grid"
                          pagination={true}
                          rowSelection="multiple"
                          onSelectionChanged={onSelectionChanged}
                          paginationPageSizeSelector={[50, 100]}
                          localeText={{
                            pageSizeSelectorLabel: "Rows per page",
                          }}
                          getRowClass={(params) => "no-selection-color"}
                          paginationPageSize={pageSize}
                          onPaginationChanged={onPaginationChanged}
                        />
                      </div>
                    </Box>
                    <div
                      style={{
                        // position: "relative",
                        // bottom: "40px",
                        // justifyContent: "flex-end",
                        position: "relative",
                        bottom: "40px",
                        display: "flex",
                        justifyContent: "flex-end",
                        overflowX: "auto",
                      }}
                    >
                      <Tooltip
                        title={
                          selectedHeader === null ||
                          // selectedMaterial === null ||
                          filteredSelectedRows.length === 0 ||
                          (filteredSelectedRows.length < 2 &&
                            filteredSelectedRows[0] &&
                            filteredSelectedRows[0]["Origin Country"] ===
                              selectedHeader)
                            ? "Please select origin and destination country in the above table to proceed."
                            : ""
                        }
                        slotProps={{
                          popper: {
                            sx: {
                              [`& .${tooltipClasses.tooltip}`]: {
                                fontFamily: `"Inter", sans-serif !important`,
                                fontSize: "15px",
                                color: "#fff", // text color
                                backgroundColor: "#5526b7", // background color
                              },
                            },
                          },
                        }}
                        arrow
                      >
                        <span>
                          <Button
                            variant="contained"
                            sx={{
                              borderRadius: "8px",
                              border: "1px solid var(--between-1020, #4A4AFF)",
                              opacity: " 0.8",
                              background:
                                selectedHeader === null ||
                                selectedRows.length < 1
                                  ? "#F4F2FF"
                                  : "blue",
                            }}
                            disabled={
                              selectedHeader === null ||
                              // selectedMaterial === null ||
                              filteredSelectedRows.length === 0 ||
                              (filteredSelectedRows.length < 2 &&
                                filteredSelectedRows[0] &&
                                filteredSelectedRows[0]["Origin Country"] ===
                                  selectedHeader)
                            }
                            // selectedHeader === null || selectedRows.length < 1}
                            onClick={() => {
                              setAllowNavigation(true);
                              navigate("/detail-view", {
                                state: {
                                  selectedRows: filteredSelectedRows,
                                  // selectedRows: selectedRows,
                                  // filteredSelectedRows,
                                  selectedSubCategory,
                                  // selectedSubCategoryValue: selectedSubCategory,
                                  selectedHeader,
                                  selectedMaterial,
                                  destinationCountryList,
                                  from: "dashboard",
                                  selectedHSCode,
                                },
                              });
                            }}
                          >
                            Click for more details
                          </Button>
                        </span>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Box>
        </div>
      </Box>
    </>
  );
}

export default ImportTariff;
